module.exports = __webpack_public_path__ + "static/media/no_search.d04eaa6f.png";